import { AxiosResponse } from "axios";
import API from "../api";
import { JobDocument } from "../models/job.document";

const ROUTE_NAME = "job/documents";

const JobDocumentService = {
  async count(options?: any): Promise<AxiosResponse<number>> {
    return await API.get(`/${ROUTE_NAME}/count`, { params: options });
  },

  async getById(id: number, options?: any): Promise<AxiosResponse<JobDocument>> {
    return await API.get(`/${ROUTE_NAME}/${id}`, { params: options });
  },
  async getAll(options?: any): Promise<AxiosResponse<JobDocument[]>> {
    return await API.get(`/${ROUTE_NAME}`, { params: options });
  },

  async create(job: { jobId: number, name: string, dueDate: string }): Promise<AxiosResponse<JobDocument>> {
    return await API.post(`/${ROUTE_NAME}`, job);
  },
  async update(id: number, agent: Partial<JobDocument>): Promise<AxiosResponse<JobDocument>> {
    return await API.put(`/${ROUTE_NAME}/${id}`, agent);
  },
  async clear(id: number | undefined, agent: any): Promise<AxiosResponse<JobDocument>> {
    return await API.put(`/${ROUTE_NAME}/clear/${id}`, agent);
  },

  async uploadFile(job: any): Promise<AxiosResponse<number>> {
    return await API.post(`/${ROUTE_NAME}/upload`, job);
  },
  async getListJobId(id: number): Promise<AxiosResponse<JobDocument[]>> {
    return await API.get(`/${ROUTE_NAME}/list`, { params: { id } });
  },

  async updateIsShared(id: number, agent: { isShared: boolean }): Promise<AxiosResponse<JobDocument>> {
    return await API.put(`/${ROUTE_NAME}/${id}/share`, agent);
  },
  async updateIsRequested(id: number, agent: { isRequested: boolean }): Promise<AxiosResponse<JobDocument>> {
    return await API.put(`/${ROUTE_NAME}/${id}/request`, agent);
  },
  async updateReview(id: number, agent: { reviewStatus: string }): Promise<AxiosResponse<JobDocument>> {
    return await API.put(`/${ROUTE_NAME}/${id}/review`, agent);
  },
  async updateListByJobId(
    jobId: number,
    documents?: JobDocument[]
  ): Promise<AxiosResponse<boolean>> {
    return await API.put(`/${ROUTE_NAME}/list/${jobId}`, documents);
  },
};

export default JobDocumentService;
